import { apiClient } from '../api/client';

export interface FormQuestion {
  id: string;
  question: string;
  type: 'SHORT_TEXT' | 'LONG_TEXT' | 'SINGLE_CHOICE' | 'MULTIPLE_CHOICE';
  isRequired: boolean;
  order: number;
  options: string[];
  /** Regras da resposta de texto: só dígitos e limites de caracteres. */
  numbersOnly?: boolean;
  minLength?: number | null;
  maxLength?: number | null;
}

export interface Form {
  id: string;
  storeId: string;
  title: string;
  slug: string;
  description?: string;
  isActive: boolean;
  reapplyable: boolean;
  startsAt?: string;
  endsAt?: string;
  createdAt: string;
  updatedAt?: string;
  questions?: FormQuestion[];
}

export interface MySubmissionStatus {
  hasSubmitted: boolean;
  submissionId: string | null;
  submittedAt: string | null;
}

export interface MySubmission {
  id: string;
  formTitle: string;
  formSlug: string;
  status: 'PENDING' | 'APPROVED' | 'REJECTED';
  observation: string | null;
  reviewedAt: string | null;
  submittedAt: string;
}

export const formService = {
  async listActiveForms(storeId: string) {
    return apiClient.get<{ forms: Form[] }>(`/public/stores/${storeId}/forms`);
  },

  async getFormBySlug(storeId: string, slug: string) {
    return apiClient.get<Form>(`/public/stores/${storeId}/forms/${slug}`);
  },

  async submitForm(
    storeId: string,
    slug: string,
    answers: Array<{ questionId: string; answer: string[] }>,
  ) {
    return apiClient.post<{ submissionId: string }>(
      `/public/stores/${storeId}/forms/${slug}/submit`,
      { answers },
    );
  },

  async getMySubmissions(storeId: string) {
    return apiClient.get<{ submissions: MySubmission[] }>(`/public/stores/${storeId}/players/my-submissions`);
  },

  async getMySubmissionDetail(storeId: string, submissionId: string) {
    return apiClient.get<{
      id: string;
      status: 'PENDING' | 'APPROVED' | 'REJECTED';
      observation: string | null;
      reviewedAt: string | null;
      submittedAt: string;
      answers: Array<{ question: string; questionType: string; answer: string[] }>;
    }>(`/public/stores/${storeId}/players/my-submissions/${submissionId}`);
  },

  async getMySubmission(storeId: string, slug: string) {
    return apiClient.get<MySubmissionStatus>(
      `/public/stores/${storeId}/forms/${slug}/my-submission`,
    );
  },
};
